/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvidenceMatchResult } from './EvidenceMatchResult';
import {
    EvidenceMatchResultFromJSON,
    EvidenceMatchResultFromJSONTyped,
    EvidenceMatchResultToJSON,
    EvidenceMatchResultToJSONTyped,
} from './EvidenceMatchResult';
import type { EvidenceScoreSubmission } from './EvidenceScoreSubmission';
import {
    EvidenceScoreSubmissionFromJSON,
    EvidenceScoreSubmissionFromJSONTyped,
    EvidenceScoreSubmissionToJSON,
    EvidenceScoreSubmissionToJSONTyped,
} from './EvidenceScoreSubmission';
import type { EvidenceMatchPhoto } from './EvidenceMatchPhoto';
import {
    EvidenceMatchPhotoFromJSON,
    EvidenceMatchPhotoFromJSONTyped,
    EvidenceMatchPhotoToJSON,
    EvidenceMatchPhotoToJSONTyped,
} from './EvidenceMatchPhoto';
import type { CompetitionOverwolfVerification } from './CompetitionOverwolfVerification';
import {
    CompetitionOverwolfVerificationFromJSON,
    CompetitionOverwolfVerificationFromJSONTyped,
    CompetitionOverwolfVerificationToJSON,
    CompetitionOverwolfVerificationToJSONTyped,
} from './CompetitionOverwolfVerification';
import type { EvidenceDisputeItem } from './EvidenceDisputeItem';
import {
    EvidenceDisputeItemFromJSON,
    EvidenceDisputeItemFromJSONTyped,
    EvidenceDisputeItemToJSON,
    EvidenceDisputeItemToJSONTyped,
} from './EvidenceDisputeItem';

/**
 * Match evidence including results, submissions, verification, screenshots, and disputes
 * @export
 * @interface EvidenceResponse
 */
export interface EvidenceResponse {
    /**
     * 
     * @type {string}
     * @memberof EvidenceResponse
     */
    matchId: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceResponse
     */
    tournamentId: string;
    /**
     * 
     * @type {EvidenceMatchResult}
     * @memberof EvidenceResponse
     */
    matchResult?: EvidenceMatchResult;
    /**
     * 
     * @type {Array<EvidenceScoreSubmission>}
     * @memberof EvidenceResponse
     */
    submissions: Array<EvidenceScoreSubmission>;
    /**
     * 
     * @type {CompetitionOverwolfVerification}
     * @memberof EvidenceResponse
     */
    overwolfVerification?: CompetitionOverwolfVerification;
    /**
     * 
     * @type {Array<EvidenceMatchPhoto>}
     * @memberof EvidenceResponse
     */
    matchPhotos: Array<EvidenceMatchPhoto>;
    /**
     * 
     * @type {Array<EvidenceDisputeItem>}
     * @memberof EvidenceResponse
     */
    disputes: Array<EvidenceDisputeItem>;
}

/**
 * Check if a given object implements the EvidenceResponse interface.
 */
export function instanceOfEvidenceResponse(value: object): value is EvidenceResponse {
    if (!('matchId' in value) || value['matchId'] === undefined) return false;
    if (!('tournamentId' in value) || value['tournamentId'] === undefined) return false;
    if (!('submissions' in value) || value['submissions'] === undefined) return false;
    if (!('matchPhotos' in value) || value['matchPhotos'] === undefined) return false;
    if (!('disputes' in value) || value['disputes'] === undefined) return false;
    return true;
}

export function EvidenceResponseFromJSON(json: any): EvidenceResponse {
    return EvidenceResponseFromJSONTyped(json, false);
}

export function EvidenceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidenceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'],
        'tournamentId': json['tournamentId'],
        'matchResult': json['matchResult'] == null ? undefined : EvidenceMatchResultFromJSON(json['matchResult']),
        'submissions': ((json['submissions'] as Array<any>).map(EvidenceScoreSubmissionFromJSON)),
        'overwolfVerification': json['overwolfVerification'] == null ? undefined : CompetitionOverwolfVerificationFromJSON(json['overwolfVerification']),
        'matchPhotos': ((json['matchPhotos'] as Array<any>).map(EvidenceMatchPhotoFromJSON)),
        'disputes': ((json['disputes'] as Array<any>).map(EvidenceDisputeItemFromJSON)),
    };
}

export function EvidenceResponseToJSON(json: any): EvidenceResponse {
    return EvidenceResponseToJSONTyped(json, false);
}

export function EvidenceResponseToJSONTyped(value?: EvidenceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'tournamentId': value['tournamentId'],
        'matchResult': EvidenceMatchResultToJSON(value['matchResult']),
        'submissions': ((value['submissions'] as Array<any>).map(EvidenceScoreSubmissionToJSON)),
        'overwolfVerification': CompetitionOverwolfVerificationToJSON(value['overwolfVerification']),
        'matchPhotos': ((value['matchPhotos'] as Array<any>).map(EvidenceMatchPhotoToJSON)),
        'disputes': ((value['disputes'] as Array<any>).map(EvidenceDisputeItemToJSON)),
    };
}

